 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TITLEPAGE from '@/components/titlepage'
 import CONTENTS from '@/components/contents'
 import COPYRIGHT from '@/components/copyright'
 import BOOKSINTHECIRCUITFAESERIESBYGENEVIEVEISEULTELDREDGE from '@/components/booksinthecircuitfaeseriesbygenevieveiseulteldredge'
 import DEDICATION from '@/components/dedication'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import CHAPTER012 from '@/components/chapter012'
 import CHAPTER013 from '@/components/chapter013'
 import CHAPTER014 from '@/components/chapter014'
 import CHAPTER015 from '@/components/chapter015'
 import CHAPTER016 from '@/components/chapter016'
 import CHAPTER017 from '@/components/chapter017'
 import CHAPTER018 from '@/components/chapter018'
 import CHAPTER019 from '@/components/chapter019'
 import CHAPTER020 from '@/components/chapter020'
 import CHAPTER021 from '@/components/chapter021'
 import CHAPTER022 from '@/components/chapter022'
 import CHAPTER023 from '@/components/chapter023'
 import CHAPTER024 from '@/components/chapter024'
 import CHAPTER025 from '@/components/chapter025'
 import CHAPTER026 from '@/components/chapter026'
 import CHAPTER027 from '@/components/chapter027'
 import CHAPTER028 from '@/components/chapter028'
 import CHAPTER029 from '@/components/chapter029'
 import CHAPTER030 from '@/components/chapter030'
 import EPILOGUE from '@/components/epilogue'
 import THESERIESCONTINUESWITHEIDOLON from '@/components/theseriescontinueswitheidolon'
 import REVIEWREQUEST from '@/components/reviewrequest'
 import MORIBUND from '@/components/moribund'
 import DERAILED from '@/components/derailed'
 import OUROBOROS from '@/components/ouroboros'
 import DETHRONED from '@/components/dethroned'
 import INIMICAL from '@/components/inimical'
 import REKINDLED from '@/components/rekindled'
 import NEMESIS from '@/components/nemesis'
 import EIDOLON from '@/components/eidolon'
 import THEGIRLINTHEGLASSBOX from '@/components/thegirlintheglassbox'
 import THEADVENTURESOFMARISOLHOLMESBYMAJANKAVERSTRAETE from '@/components/theadventuresofmarisolholmesbymajankaverstraete'
 import ACKNOWLEDGMENTS from '@/components/acknowledgments'
 import ABOUTTHEAUTHOR from '@/components/abouttheauthor'
 import NEWSLETTERLINKS from '@/components/newsletterlinks'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/contents",
 			"name" : "contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/booksinthecircuitfaeseriesbygenevieveiseulteldredge",
 			"name" : "booksinthecircuitfaeseriesbygenevieveiseulteldredge",
 			"component" : BOOKSINTHECIRCUITFAESERIESBYGENEVIEVEISEULTELDREDGE
 		},
 		{
 			"path" : "/dedication",
 			"name" : "dedication",
 			"component" : DEDICATION
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js